module.exports = __webpack_public_path__ + "img/15.6b3d9ec9.jpg";